import { useSyncExternalStore } from 'react';

const MOBILE_MEDIA_QUERY = '(max-width: 767px)';

function getMql(): MediaQueryList | null {
    if (typeof window === 'undefined') return null;
    return window.matchMedia(MOBILE_MEDIA_QUERY);
}

function subscribe(onChange: () => void): () => void {
    const mql = getMql();
    if (!mql) return () => {};
    mql.addEventListener('change', onChange);
    return () => mql.removeEventListener('change', onChange);
}

function getSnapshot(): boolean {
    return getMql()?.matches ?? false;
}

function getServerSnapshot(): boolean {
    return getSnapshot();
}

/**
 * Reactive mobile breakpoint (< 768px). Updates on resize via matchMedia.
 * Excludes tablets (768px+) and desktops (1024px+).
 */
export function useIsMobileViewport(): boolean {
    return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}
